import "../../../css/tailwind.frontend.css";
import FaqHandler from "./modules/FaqHandler";
import HeaderHandler from "./modules/HeaderHandler";
import HereAvailableHandler from "./modules/HereAvailableHandler";

new FaqHandler();
new HeaderHandler();
new HereAvailableHandler();
